export const formatBrazilianPhone = (value: string): string => {
	const digits = String(value || "").replace(/\D/g, "");
	const nationalNumber =
		digits.startsWith("55") && digits.length > 11 ? digits.slice(2) : digits;
	const limited = nationalNumber.slice(0, 11);

	if (limited.length <= 2) return limited;
	if (limited.length <= 6)
		return `(${limited.slice(0, 2)}) ${limited.slice(2)}`;
	if (limited.length <= 10) {
		return `(${limited.slice(0, 2)}) ${limited.slice(2, 6)}-${limited.slice(
			6
		)}`;
	}
	return `(${limited.slice(0, 2)}) ${limited.slice(2, 7)}-${limited.slice(7)}`;
};

export const normalizeBrazilianWhatsAppPhone = (value: string): string => {
	let digits = String(value || "").replace(/\D/g, "");
	while (digits.startsWith("0")) digits = digits.slice(1);
	if (digits.length === 10 || digits.length === 11) digits = `55${digits}`;
	return /^55\d{10,11}$/.test(digits) ? digits : "";
};

export const buildWhatsAppUrl = (
	phone: string,
	message: string
): string | null => {
	const normalizedPhone = normalizeBrazilianWhatsAppPhone(phone);
	if (!normalizedPhone) return null;
	return `https://wa.me/${normalizedPhone}?text=${encodeURIComponent(
		message || ""
	)}`;
};
